import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered fade-up reveal wrapper.
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

// Section eyebrow / tag label.
export const Tag = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 font-condensed text-sm uppercase tracking-[0.25em] ${
      dark ? "text-brand-azure" : "text-brand-blue"
    }`}
  >
    <span className="h-px w-8 bg-current opacity-60" />
    {children}
  </span>
);
